export default __webpack_public_path__ + "static/media/4.49ef7c31.png";